module.exports = __webpack_public_path__ + "static/media/kaggle.199ad3c9.png";